<div
  class="admin-layout"
  [class.sidebar-collapsed]="sidebarCollapsed"
>

  <aside
    class="sidebar"
    [class.collapsed]="sidebarCollapsed"
  >

    <div class="sidebar-brand">

      <div class="brand-content">

        <div class="brand-icon">
          🍽️
        </div>

        <div
          class="brand-text"
          *ngIf="!sidebarCollapsed"
        >
          <strong>
            Meu Menu
          </strong>

          <span>
            Painel administrativo
          </span>
        </div>

      </div>

      <button
        type="button"
        class="sidebar-toggle"
        [attr.aria-label]="
          sidebarCollapsed
            ? 'Expandir menu'
            : 'Recolher menu'
        "
        [attr.title]="
          sidebarCollapsed
            ? 'Expandir menu'
            : 'Recolher menu'
        "
        (click)="toggleSidebar()"
      >

        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          [class.rotated]="sidebarCollapsed"
        >
          <path
            d="M15 18l-6-6 6-6"
          ></path>
        </svg>

      </button>

    </div>

    <nav class="sidebar-menu">

      <a
        *ngIf="can('DASHBOARD_VIEW')"
        routerLink="/admin/dashboard"
        routerLinkActive="active"
      >
        <span class="menu-icon">
          📊
        </span>

        <span>
          Dashboard
        </span>
      </a>

      <a
        *ngIf="can('ORDERS_VIEW')"
        routerLink="/admin/pedidos"
        routerLinkActive="active"
      >
        <span class="menu-icon">
          🧾
        </span>

        <span>
          Pedidos
        </span>
      </a>

      <!-- MESAS -->

   <!-- MESAS -->

<div class="menu-group">

  <button
    type="button"
    class="menu-parent"
    title="Mesas"
    [class.active]="isTablesRouteActive"
    (click)="toggleTablesMenu()"
  >

    <span class="menu-parent-content">

      <span class="menu-icon">
        🪑
      </span>

      <span class="menu-label">
        Mesas
      </span>

    </span>

    <span
      class="submenu-arrow"
      [class.open]="tablesMenuOpen"
    >
      ▾
    </span>

  </button>


  <!-- SUBMENU DESKTOP -->

  <div
    class="submenu desktop-tables-submenu"
    *ngIf="tablesMenuOpen"
  >

    <a
      routerLink="/admin/mesas"
      routerLinkActive="active"
    >
      <span class="submenu-icon">
        📋
      </span>

      <span>
        Gestão de mesas
      </span>
    </a>

    <a
      routerLink="/admin/gerenciar-mesas"
      routerLinkActive="active"
    >
      <span class="submenu-icon">
        🔳
      </span>

      <span>
        Cadastro e QR Codes
      </span>
    </a>

  </div>

</div>

      <a
        *ngIf="can('PRODUCTS_VIEW')"
        routerLink="/admin/produtos"
        routerLinkActive="active"
      >
        <span class="menu-icon">
          🍔
        </span>

        <span>
          Produtos
        </span>
      </a>

      <a
        routerLink="/admin/cupons"
        routerLinkActive="active"
      >
        <span class="menu-icon">
          🎟️
        </span>

        <span>
          Cupons
        </span>
      </a>

      <a
        *ngIf="can('RESTAURANTS_VIEW')"
        routerLink="/admin/restaurantes"
        routerLinkActive="active"
      >
        <span class="menu-icon">
          🏪
        </span>

        <span>
          Restaurantes
        </span>
      </a>

      <a
        *ngIf="can('CASH_FLOW_VIEW')"
        routerLink="/admin/fluxo-caixa"
        routerLinkActive="active"
      >
        <span class="menu-icon">
          💰
        </span>

        <span>
          Fluxo de Caixa
        </span>
      </a>



<!-- TUTORIAL -->

<a
  routerLink="/admin/tutorial"
  routerLinkActive="active"
>
  <span class="menu-icon">
    📖
  </span>

  <span>
    Tutorial
  </span>
</a>







      <a
        routerLink="/admin/assinatura"
        routerLinkActive="active"
        class="footer-action"
      >
        <span class="menu-icon">
          💳
        </span>

        <span>
          Minha assinatura
        </span>
      </a>

    </nav>

    <!-- SUBMENU MESAS MOBILE -->

 <!-- SUBMENU MESAS MOBILE -->

<div
  class="mobile-tables-submenu"
  *ngIf="tablesMenuOpen"
>

  <a
    routerLink="/admin/mesas"
    routerLinkActive="active"
    (click)="closeTablesMenuOnMobile()"
  >
    <span class="submenu-icon">
      📋
    </span>

    <span>
      Gestão de mesas
    </span>
  </a>

  <a
    routerLink="/admin/gerenciar-mesas"
    routerLinkActive="active"
    (click)="closeTablesMenuOnMobile()"
  >
    <span class="submenu-icon">
      🔳
    </span>

    <span>
      Cadastro e QR Codes
    </span>
  </a>

</div>

    <div class="sidebar-footer">

      <div class="user-card">

        <div class="user-avatar">
          {{ userInitial }}
        </div>

        <div class="user-info">

          <strong>
            {{ userName }}
          </strong>

          <span *ngIf="userEmail">
            {{ userEmail }}
          </span>

          <small *ngIf="roleLabel">
            {{ roleLabel }}
          </small>

        </div>

      </div>

      <div class="footer-actions">

        <a
          *ngIf="can('SETTINGS_VIEW')"
          routerLink="/admin/configuracoes"
          routerLinkActive="active"
          class="footer-action"
        >
          <span class="menu-icon">
            ⚙️
          </span>

          <span>
            Configurações
          </span>
        </a>

        <button
          type="button"
          class="footer-action logout-button"
          (click)="logout()"
        >
          <span class="menu-icon">
            🚪
          </span>

          <span>
            Sair
          </span>
        </button>

      </div>

    </div>

  </aside>

  <main class="admin-content">

    <router-outlet>
    </router-outlet>

  </main>

</div>